import qs from 'qs';

const defaultParseOptions = {
  ignoreQueryPrefix: true,
};

const defaultStringifyOptions = {
  encodeValuesOnly: true,
};

export default function getEncodedQueryString(parameter?: {
  search?: string;
  parseOptions?: qs.IParseOptions;
  stringifyOptions?: qs.IStringifyOptions;
}) {
  const { search, parseOptions, stringifyOptions } = parameter || {};
  const windowSearchStr = typeof window === 'undefined' ? '' : window.location.search;

  const decoded = decodeURIComponent(search ?? windowSearchStr);
  const query = qs.parse(decoded, {
    ...defaultParseOptions,
    ...parseOptions,
  });

  return qs.stringify(query, {
    ...defaultStringifyOptions,
    ...stringifyOptions,
  });
}
